// @flow
export function noticeError(error: Error, errorString?: string): void {
    if (window.newrelic) {
        window.newrelic.noticeError(error);
    } else {
        console.error(
            'Tried to invoke newrelic.noticeError when it was not present.',
            errorString,
            error
        );
    }
}
